import { createContext, useContext } from 'react'
import { UserId } from '../types/types'

export const UserContext = createContext<UserId | null>(null)

export const useUserContext = (): UserId | null => {
  return useContext(UserContext)
}